import { useMemo } from 'react'
import { createAnswerService } from '@/lib/api'

export type AnswerApiOptions = {
  baseUrl: string
  acquireToken: () => Promise<string>
  fetchImpl?: typeof fetch
}

/** Memoized generated-client instance — shared by every hook that talks to
 * the answer-service REST surface. */
export function useAnswerApi(options: AnswerApiOptions): ReturnType<typeof createAnswerService> {
  return useMemo(
    () =>
      createAnswerService({
        baseUrl: options.baseUrl,
        acquireToken: options.acquireToken,
        ...(options.fetchImpl !== undefined ? { fetchImpl: options.fetchImpl } : {}),
      }),
    [options.baseUrl, options.acquireToken, options.fetchImpl],
  )
}
